/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Color } from 'three';
/**
 * optional settings for the transparency
 */
export class TransparencyRules {
}
/**
 * how text are to be displayed
 */
export class Text2DStyle {
    constructor() {
        this.color = new Color(1, 1, 1);
        this.asBillboard = false;
    }
}
//# sourceMappingURL=Text2DStyle.js.map